
class OverlayBackground extends HTMLElement {
  constructor(){
    super();
    this.context = this.getAttribute('for');
    this.delay = this.getAttribute('data-delay') ? this.getAttribute('data-delay') : 0;
    window.addEventListener('init-overlay', (e) => {
      if(e.detail == this.context) {
        document.querySelector(`${e.detail} > .overlay-modal`).style.zIndex = parseInt(this.dataset.z_index) + 1;
        setTimeout(() => {document.querySelector(`${e.detail} > .overlay-modal`).setAttribute('data-open', true);},this.delay );
        this.initOverlayBackground();
      }
    });
    window.addEventListener('close-overlay', (e) => {
      if(e.detail == this.context) {
        document.querySelector(`${e.detail} > .overlay-modal`).setAttribute('data-open', false);
        setTimeout(() => {this.closeOverlayBackground();}, this.delay);
      }
    })
  }
  initOverlayBackground(){
    this.style.display = 'block';
    this.style.backgroundColor = this.dataset.color;
    this.style.opacity = this.dataset.opacity;
    this.style.zIndex = this.dataset.z_index;
    let scrolledPosition = window.scrollY;
    if(this.dataset.scroll == 'false') {
      document.body.setAttribute('data-scrollable', false);
      //locks the screen in the current position when overlay is active, while still disabling scroll
      document.body.style.top = `${ scrolledPosition * -1}px`;
    }
  }

  closeOverlayBackground(){
    //prevents the jumping behavior when closing overlay by forcing a scroll to the previous position of the page
    let previousPosition = parseInt(document.body.style.top.replace('px', '')) * -1;
    this.style.display = 'none';
    document.body.removeAttribute('data-scrollable');
    window.scrollTo(0, previousPosition);
  }
}

customElements.define("overlay-background", OverlayBackground);
